<template>
    <div>
        <Login></Login>
  </div>
</template>

<script>
//import firebase from "firebase";
import Login from './admin/Login';
export default {
    components:{
        'Login':Login
    }
}
</script>

<style>

</style>